type Props = {
  className?: string
  testId?: string
  pathColor?: string | null
}

const Sync = (props: Props) => {
  const { className, testId, pathColor } = props

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={testId}
    >
      <path
        d="M16 6C16 6.475 15.6433 6.85714 15.2 6.85714H11.4667H10.4C9.95667 6.85714 9.6 6.475 9.6 6C9.6 5.525 9.95667 5.14286 10.4 5.14286H11.4667H13.27L11.5333 3.28214C10.5933 2.27857 9.32333 1.71429 8 1.71429C5.57667 1.71429 3.49333 3.28929 2.6 5.53929C2.42667 5.975 1.95667 6.17857 1.55 5.99286C1.14333 5.80714 0.953333 5.30357 1.12667 4.86786C2.26333 2.00714 4.91333 0 8 0C9.75 0 11.4267 0.742857 12.6633 2.06786L14.4 3.93214V2V1.98571V0.857143C14.4 0.382143 14.7567 0 15.2 0C15.6433 0 16 0.382143 16 0.857143V6ZM0.8 9.14286H4.53333C4.97667 9.14286 5.33333 9.525 5.33333 10C5.33333 10.475 4.97667 10.8571 4.53333 10.8571H2.73L4.46667 12.7179C5.40667 13.7214 6.67667 14.2857 8 14.2857C10.42 14.2857 12.5 12.7179 13.3967 10.4714C13.57 10.0357 14.04 9.83572 14.4467 10.0214C14.8533 10.2071 15.04 10.7107 14.8667 11.1464C13.7267 14 11.0833 16 8 16C6.25 16 4.57333 15.2571 3.33667 13.9321L1.6 12.0679V14C1.6 14.475 1.24333 14.8571 0.8 14.8571C0.356667 14.8571 0 14.475 0 14V10C0 9.525 0.356667 9.14286 0.8 9.14286Z"
        fill={pathColor || '#6A747F'}
      />
    </svg>
  )
}

export default Sync
